/**
 * Last path segment of a media URL without query/hash (safe for S3 presigned URLs).
 */
export function getFileNameFromMediaUrl(
  url: string | null | undefined,
  fallback = ''
): string {
  if (!url || typeof url !== 'string') {
    return fallback;
  }
  const trimmed = url.trim();
  if (!trimmed) {
    return fallback;
  }
  const pathOnly = trimmed.split('?')[0].split('#')[0];
  const lastSegment = pathOnly.split('/').filter(Boolean).pop() || '';
  if (!lastSegment) {
    return fallback;
  }
  try {
    return decodeURIComponent(lastSegment);
  } catch {
    return lastSegment;
  }
}
